import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import BaseEntitySelector from '../../../yinzhilv/base-entity-selector-0000/1.2.2/index.vue';
import consumer_hotel_common_cityList from "../../../../lib/data-service/haolv-default/consumer_hotel_common_cityList";

export default {
    components: {
        BaseEntitySelector,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: null,
        },
        autoInit: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            value_for_v_model: null,
        };
    },
    watch: {
        value: {
            handler(pNewValue, pOldValue) {
                const __this = this;
                __this.value_for_v_model = pNewValue;
            },
            immediate: true,
        },
        value_for_v_model(pNewValue, pOldValue) {
            const __this = this;
            __this.$emit('input', pNewValue);
        }
    },
    methods: {
        __init(pInitParameter) {
            const __this = this;

            if (!pInitParameter) pInitParameter = {};

            const defaultInitParameter = {};
            defaultInitParameter.placeholder_text = '请选择目的城市';

            const init_parameter = extend({}, defaultInitParameter, pInitParameter);
            const placeholder_text = init_parameter.placeholder_text;

            __this.$refs.aBaseEntitySelector.init({
                entity_define: {
                    property_name_for_id: `cityId`,
                    property_name_for_code: `cityId`,
                    property_name_for_name: `cityCn`,
                    property_name_for_pin_yin: `cityPinyin`,
                    property_name_for_jian_pin: `cityPinyinSimp`,
                    property_name_for_first_letter: `initial`,
                    property_name_for_extend_001: ``, // 扩展字段-code
                    property_name_for_extend_002: ``, // 扩展字段-name
                },
                placeholder_text,
                get_data_source() {
                    return Q.when()
                        .then(function () {
                            return consumer_hotel_common_cityList();
                        })
                        .then(function (data) {
                            let all_entity_list = data.citys;
                            const o = {};
                            o.all_entity_list = all_entity_list;
                            return o;
                        })
                        ;
                },
                panel_select_entity: {
                    get_tab_list(pParameter) {
                        if (!pParameter) pParameter = {};
                        const all_entity_list = pParameter.all_entity_list;
                        const init_parameter = pParameter.init_parameter;
                        const property_name_for_first_letter = init_parameter.entity_define.property_name_for_first_letter;

                        const hot_entity_list = _.chain(all_entity_list)
                            .filter(function (m) {
                                return 1 === 1
                                    && m.isHot === `Y`
                                    && !m.airports
                                    ;
                            })
                            .value()
                        ;

                        const first_letter_list = _.chain(all_entity_list)
                            .filter(function (m) {
                                return 1 === 1
                                    && !m.airports
                                    ;
                            })
                            .groupBy(function (m) {
                                return m[property_name_for_first_letter];
                            })
                            .map(function (property_value, property_name) {
                                const first_letter = property_name;
                                const entity_list = property_value;
                                const o = {};
                                o.first_letter = first_letter;
                                o.entity_list = entity_list;
                                return o;
                            })
                            .value()
                        ;
                        // console.log(first_letter_list);

                        const tab_list_000 = [
                            {
                                first_letter_list: [
                                    {first_letter: `A`},
                                    {first_letter: `B`},
                                    {first_letter: `C`},
                                    {first_letter: `D`},
                                    {first_letter: `E`},
                                ],
                            },
                            {
                                first_letter_list: [
                                    {first_letter: `F`},
                                    {first_letter: `G`},
                                    {first_letter: `H`},
                                    {first_letter: `I`},
                                    {first_letter: `J`},
                                ],
                            },
                            {
                                first_letter_list: [
                                    {first_letter: `K`},
                                    {first_letter: `L`},
                                    {first_letter: `M`},
                                    {first_letter: `N`},
                                    {first_letter: `O`},
                                ],
                            },
                            {
                                first_letter_list: [
                                    {first_letter: `P`},
                                    {first_letter: `Q`},
                                    {first_letter: `R`},
                                    {first_letter: `S`},
                                    {first_letter: `T`},
                                ],
                            },
                            {
                                first_letter_list: [
                                    {first_letter: `U`},
                                    {first_letter: `V`},
                                    {first_letter: `W`},
                                    {first_letter: `X`},
                                    {first_letter: `Y`},
                                    {first_letter: `Z`},
                                ],
                            },
                        ];

                        const tab_list_002 = _.chain(tab_list_000)
                            .map(function (m) {
                                const first_letter_list = m.first_letter_list;
                                const title = _.chain(first_letter_list)
                                    .map(function (m) {
                                        return m.first_letter;
                                    })
                                    .value()
                                    .join(``)
                                ;

                                const o = {};
                                o.type = `multiple-letters`;
                                o.title = title;
                                o.first_letter_list = first_letter_list;
                                return o;
                            })
                            .value()
                        ;

                        let tab_list_003 = [];
                        tab_list_003.push({
                            type: `hot-entity`,
                            title: `热门`,
                            hot_entity_list: hot_entity_list,
                        });

                        tab_list_003 = tab_list_003.concat(tab_list_002);

                        const tab_list_004 = _.chain(tab_list_003)
                            .map(function (m) {
                                m.active = false;
                                return m;
                            })
                            .value()
                        ;

                        const all_first_letter_list = _.chain(tab_list_002)
                            .map(function (m) {
                                return m.first_letter_list;
                            })
                            .flatten()
                            .map(function (m) {
                                const first_letter = m.first_letter;
                                // const entity_list = m.entity_list;

                                let entity_list = [];
                                const query = _.chain(first_letter_list)
                                    .find(function (m) {
                                        return m.first_letter === first_letter;
                                    })
                                    .value()
                                ;
                                if (query) {
                                    entity_list = query.entity_list;
                                }

                                m.entity_list = entity_list;
                                return m;
                            })
                            .value()
                        ;
                        // console.log(all_first_letter_list);

                        const tab_list = tab_list_004;
                        // console.log(tab_list);

                        const o = {};
                        o.tab_list = tab_list;
                        return Q.resolve(o);
                    },
                },
                panel_filter_entity: {
                    title: `名称`,
                    is_show_code: false,
                },
                input: {
                    // event_handler_set_input_text(args) {
                    //     const __this__ = args.__this;
                    //     const selected_entity = args.selected_entity;
                    //     let name;
                    //     if (selected_entity) {
                    //         name = selected_entity.name_custom_001;
                    //     } else {
                    //         name = ``;
                    //     }
                    //     return {
                    //         input_text: name,
                    //     }
                    // },
                },
                panel_use_situation: `000`,
            });
        },

        //--------------------------------------------------------------------------------------------------------------

        init(pInitParameter) {
            const __this = this;
            __this.__init(pInitParameter);
        },

        set_entity(pParameter) {
            const __this = this;

            return __this.$refs.aBaseEntitySelector.set_entity(pParameter);
        },

    },
    created() {
    },
    mounted() {
        const __this = this;
        if (__this.autoInit) {
            __this.__init()
        }
    },
}
